import { Location } from '../types'

const extractAllChildrensFromLocationsTree = (obj: Location): Location[] => {
  if (!obj.children) {
    return []
  }

  const allChildren: Location[] = [
    {
      ...obj,
      country: obj.type === 'Country',
      lat: obj?.lat?.toString(),
      lon: obj?.lon?.toString(),
      children: null
    }
  ]

  const extractChildren = (childObj: Location) => {
    allChildren.push({
      ...childObj,
      country: childObj.type === 'Country',
      lat: childObj?.lat?.toString(),
      lon: childObj?.lon?.toString(),
      children: null
    })
    if (childObj.children) {
      childObj.children.forEach(extractChildren)
    }
  }

  obj.children.forEach(extractChildren)
  return allChildren
}

export default extractAllChildrensFromLocationsTree
